import RemoteResult from "@/entities/common/remote_result"
import IdRequest from "@/entities/common/request/id_request"
import Poster from "@/util/poster"
import RestPaths from "@/util/rest_paths"
import BaseLogic from "../base_logic"
import FilialeInfo from "@/entities/common/filiale_info"

export default class FilialeInfoLogic extends BaseLogic {
  filialeInfo: FilialeInfo = null

  init() {
    var request = new IdRequest()
    request.id = this.filiale.filialeId

    Poster.postUser<RemoteResult<FilialeInfo>>(
      RestPaths.filialeInfo,
      request
    ).then((response) => {
      if (response.data.success) {
        this.filialeInfo = response.data.payload
      }
    })
  }
}
